import Vue from 'vue'
import Router from 'vue-router'
import Role from '../main/permission/Role.vue'
import DashBoard from '../main/home/Dashboard.vue'
import Login from '../main/system/Login.vue'
import MenuSlider from '../main/home/MenuSlider.vue'
import Resource from '../main/permission/Resource.vue'
import Admin from '../main/permission/Admin.vue'
//import Img from '../main/admin/Imgs.vue'
import TagList from '../main/admin/TagList.vue'
import ImgList from '../main/admin/ImgList.vue'
import WxUser from '../main/admin/WxUser'







Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: '',
      component: MenuSlider,
      children: [
        {
          path: '/',
          name: "DashBoard",
          component: DashBoard
        }, {
          path: '/role',
          name: 'Role',
          component: Role
        },
        {
          path: '/admins',
          name: 'Admin',
          component: Admin
        },
        {
          path: '/resources',
          name: 'Resource',
          component: Resource
        },
        {
          path:'/wx/user',
          name:'WxUser',
          component:WxUser
        },
        {
          path:'/img-list',
          component:ImgList
        },
        {
          path:'/tags',
          component:TagList
        }
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js